import { render, staticRenderFns } from "./onlinePageVirtualColumn.vue?vue&type=template&id=16e3e924&scoped=true&"
import script from "./onlinePageVirtualColumn.vue?vue&type=script&lang=js&"
export * from "./onlinePageVirtualColumn.vue?vue&type=script&lang=js&"
import style0 from "./onlinePageVirtualColumn.vue?vue&type=style&index=0&id=16e3e924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e3e924",
  null
  
)

export default component.exports